import PropTypes from "prop-types";
import { forwardRef } from "react";

import IconButton from "@mui/material/IconButton";

import { ButtonAnimate } from "../../../components/Animate";

const APlayerControlButton = forwardRef(
  ({ children, color = "inherit", ...other }, ref) => (
    <ButtonAnimate>
      <IconButton
        ref={ref}
        color={color}
        sx={{
          padding: { xs: 0.5, sm: 1 },
          "& svg, & span": { transition: "transform .3s" },
          "&:hover svg, &:hover span": {
            msTransform: "scale(1.3)",
            WebkitTransform: "scale(1.3)",
            transform: "scale(1.3)",
          },
        }}
        {...other}
      >
        {children}
      </IconButton>
    </ButtonAnimate>
  )
);

APlayerControlButton.propTypes = {
  children: PropTypes.node,
};

export default APlayerControlButton;
